module.exports = function() {
  return new Worker(__webpack_public_path__ + "bae0dfdb6e148f6bf1ab.worker.js");
};